import { Group, Header, Image, Text, rem, createStyles, Button, Grid, Burger, MediaQuery, useMantineTheme } from '@mantine/core';
import React from 'react'
import BdLogoSm from '../assets/images/OBRC_OBD CLR.png';
import { IconUserCircle } from '@tabler/icons-react';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from '../redux/slices/authSlice';
import axios from 'axios';
import AuthMenuBar from './AuthMenuBar';

const useStyles = createStyles((theme) => ({
  header: {
    padding: '0 !important',
  },
  bottomHeader: {
    backgroundColor: '#141b54',
    margin: 0,
    padding: 10,
    position: 'relative'
  },
  topHeader: {
    backgroundColor: '#404bad',
    margin: 0,
    padding: 5
  },
  authBar: {
    position: 'absolute',
    top: '12%',
    right: 12
  }
}));

const AppHeader = ({ hidden, toggleHidden, theme }) => {
  const { classes } = useStyles();
  
  return (
    <Header height={{ base: 50, md: 70 }} p="md" bg='#141b54'>
      <div style={{ display: 'flex', alignItems: 'center', height: '100%', justifyContent: 'space-between' }}>
        <MediaQuery largerThan="sm" styles={{ display: 'none' }}>
          <Burger
            opened={hidden}
            onClick={() => toggleHidden()}
            size="sm"
            color={theme.colors.gray[6]}
            mr="xl"
          />
        </MediaQuery>
        <Image width={rem(38)} src={BdLogoSm} />
        <AuthMenuBar />
      </div>
    </Header>
  )
}

export default AppHeader;